import { TrackerClients } from '../tracker/trackerClients'
import trackerFactory from '../tracker/trackerFactory'

export function dispatchPerformanceTrackingEvent(
  eventName: string,
  sdkLoadStartTime?: number
): void {
  if (sdkLoadStartTime !== undefined) {
    const tracker = trackerFactory(TrackerClients.websdk)
    const sdkLoadCompleteTime = Date.now()
    tracker.event(eventName, {
      startTimestamp: sdkLoadStartTime,
      endTimestamp: sdkLoadCompleteTime,
      timeToLoad: sdkLoadCompleteTime - sdkLoadStartTime,
    })
  }
}
